import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
// import "./MyBag.scss";
// import { Link, useNavigate } from "react-router-dom";
// import { BACK_ARROW } from "../../assets";
// import MyBagCard from "./MyBagCard";
// import { useDispatch, useSelector } from "react-redux";
// import myBagSlice from "../../redux/slices/myBagSlice";
// import { myBagToggle } from "../../redux/slices/myBagToggleSlice";
// import useGetUser from "../../hooks/useGetUser";
import "./MyBag.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useGetUser from "../../../hooks/useGetUser";
import { myBagToggle } from "../../../redux/slices/myBagToggleSlice";
import { BACK_ARROW } from "../../../assets";
import { toast } from "react-toastify";
import MyBagCardNew from "./MyBagCardNew";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

const MyBag = ({ setLensStep }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useGetUser();
  const myBagData = useSelector((state) => state?.myBagData?.items);
  const isBagToggled = useSelector((state) => state?.myBagToggle);
 

  const subTotal = myBagData?.reduce((total, item) => {
    // Calculate the product price based on quantity
    let productWeight = Number(item?.netWeight) * Number(item?.quantity);
    const finalWeight = Number(total) + productWeight;
    const final = finalWeight.toFixed(2);
    // console.log(final);
    return final;
  }, 0);


  const bodyRef = useRef();

  

  const isNotGo = () => {
    return myBagData?.some((item) =>
      item?.quantity < item?.lensDetails?.length ? true : false
    );
  };

  
  const goCheckOutHandle = () => {
    if (isNotGo()) {
      toast.error("Your lens quantities are more then Frames quantities!", {
        autoClose: 4000,
      });
      return;
    }
    navigate(user?.customer ? "/shopping-tray" : "/signup", {
      state: { isNewUser: user?.customer ? false : true },
    });
    dispatch(myBagToggle());
    document.body.style.overflow = "auto";
    document.body.style.height = "auto";
  };

  return (
    <div className="my_bag_main z-999999">
      <div className="container-fluid">
        {/* <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-md">
          <div className="container-fluid p-2">
            <a className="navbar-brand text-primary mr-0">Company Logo</a>
            <div className="form-inline ml-auto">
              <div
                className="btn btn-primary"
                onClick={() => setIsOpen(!isOpen)}
              >
                <i className="fa fa-bars"></i>
              </div>
            </div>
          </div>
        </nav> */}
        <div className={`my_bag bg-text_light_2 ${isBagToggled === true ? "active" : ""}`}>
          {user?.customer ? (
            <div className="my_bag_header">
              <span className="my_bag_header_text ">
                My Bag <span className=""> - {myBagData?.length}</span>
              </span>
            </div>
          ) : (
            <div className="my_bag_header lato-regular">
              <span
                onClick={() => {
                  navigate("/signup");
                  dispatch(myBagToggle());
                  document.body.style.overflow = "auto";
                  document.body.style.height = "auto";
                }}
                className="my_bag_header_link text-primary"
              >
                Sign in
              </span>
              <span className="my_bag_header_text text-text_dark_2">
                to speed up the checkout process
              </span>
            </div>
          )}
          <div ref={bodyRef} className="my_bag_body">
            {myBagData?.length > 0 ? (
              myBagData?.map((item, index) => {
                return (
                  <MyBagCardNew
                    key={index}
                    data={item}
                    setLensStep={setLensStep}
                  />
                );
              })
            ) : (
              <div className="no_data_found_main text-text_dark_3">No items in bag !</div>
            )}
            {/* {myBagData?.length > 0 ? (
              myBagData?.map((item, index) => {
                return (
                  <MyBagCard
                    key={index}
                    data={item}
                    setLensStep={setLensStep}
                  />
                );
              })
            ) : (
              <div className="no_data_found_main">No items in bag !</div>
            )} */}
          </div>
          {myBagData?.length !== 0 && (
            <div className="my_bag_bottom_main">
              <div
                onClick={() => {
                  navigate("shopping-bag");
                  dispatch(myBagToggle());
                  document.body.style.overflow = "auto";
                  document.body.style.height = "auto";
                }}
                className="view_bag_btn"
              >
                <span className="cormorant-semibold">View bag</span>
                <img src={BACK_ARROW} alt="" className="w-6" />
              </div>
              <div className="lato-medium checkout_btn d-flex justify-between" onClick={() => goCheckOutHandle()}>
                <div className="lato-bold">Total Net wt :&nbsp;{subTotal}&nbsp;g</div>
                <span>CHECKOUT </span>
              </div>
            </div>
          )}
        </div>
        <div
          className={`my_bag_overlay ${isBagToggled === true ? "active" : ""}`}
          onClick={() => {
            dispatch(myBagToggle());
            document.body.style.overflow = "auto";
            document.body.style.height = "auto";
            bodyRef.current.scrollTop = 0;
          }}
        ></div>
      </div>
    </div>
  );
};

export default MyBag;
